module.exports = __webpack_public_path__ + "img/tree-fire-flame-01-a.4a615b9f.png";